import UnratedRating from './UnratedRating.jsx';
import './UnratedRating.css';

export default UnratedRating;
